
import Collection from '../../Component/Collection';
import HeroSection from '../../Component/HeroSection';
import Newsletter from '../../Component/Newsletter';
// import './App.css';
// import Header from './Component/Header/Header';

function Home() {
  return (
    <>
    <HeroSection/>
    <Collection/>
    <Newsletter/>
    </>
  );
}

export default Home;
